export default {"src":"/_next/static/media/sc.2af380c1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};